import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["disabled", "label", "answer", "onComment", "isAssignmentEnded", "isCommentLoading", "isGradingLoading", "onAnswerComment", "onUpdateAnswerComment", "onDeleteAnswerComment", "comments", "setComments", "onClickAnswer", "isOnGradingProcess"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useState } from 'react';
import styled from '@xstyled/styled-components';
import { AudioPlayer, styleVariables, RichTextEditor, EditorComment, PrimaryButton } from '@lib/common';
import { Space, Tooltip } from 'antd';
import { GradingAnswer } from './base-answer.component';
import { CommentBox, CommentPreview } from '../../submission-preview';
import { EditOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpaceContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledSpace = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  display: flex;\n  justify-content: space-between;\n  color: black;\n"])));
var StyledInstructorFeedbackWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n"])));
var StyledStudentWork = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledLabel = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong);
var StyledEmptyAnswerLabel = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  font-style: italic;\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
});
var StyledAnswer = styled(Space)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var GradingEssay = function GradingEssay(_ref) {
  var _answer$value3, _answer$value4;

  var disabled = _ref.disabled,
      label = _ref.label,
      answer = _ref.answer,
      onComment = _ref.onComment,
      isAssignmentEnded = _ref.isAssignmentEnded,
      isCommentLoading = _ref.isCommentLoading,
      isGradingLoading = _ref.isGradingLoading,
      onAnswerComment = _ref.onAnswerComment,
      onUpdateAnswerComment = _ref.onUpdateAnswerComment,
      onDeleteAnswerComment = _ref.onDeleteAnswerComment,
      comments = _ref.comments,
      setComments = _ref.setComments,
      onClickAnswer = _ref.onClickAnswer,
      isOnGradingProcess = _ref.isOnGradingProcess,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      isCommentEditing = _useState[0],
      setIsCommentEditing = _useState[1];

  var editorCommentLabels = {
    save: label.save,
    cancel: label.cancel,
    comment: label.comment,
    selectColor: label.selectColor
  };
  useEffect(function () {
    if (!isCommentLoading) {
      setIsCommentEditing(false);
    }
  }, [isCommentLoading]);

  var renderComment = function renderComment() {
    var commentPreviewLabel = {
      noContent: label.noComment,
      seeMore: label.seeMore,
      seeLess: label.seeLess
    };
    var editorLabels = {
      addColumnBefore: label.addColumnBefore,
      addColumnAfter: label.addColumnAfter,
      deleteColumn: label.deleteColumn,
      addRowBefore: label.addRowBefore,
      addRowAfter: label.addRowAfter,
      deleteRow: label.deleteRow,
      deleteTable: label.deleteTable,
      mergeCells: label.mergeCells,
      splitCell: label.splitCell,
      basicColors: label.basicColors,
      bold: label.bold,
      italic: label.italic,
      moreFormatting: label.moreFormatting,
      underline: label.underline,
      strike: label.strike,
      alignLeft: label.alignLeft,
      alignCenter: label.alignCenter,
      alignRight: label.alignRight,
      bulletList: label.bulletList,
      orderedList: label.orderedList,
      textStyles: label.textStyles,
      table: label.table,
      addImage: label.addImage,
      textColor: label.textColor,
      column: label.column,
      row: label.row,
      cellColor: label.cellColor,
      addAudio: label.addAudio,
      addMath: label.addMath,
      justify: label.justify
    };

    if (disabled) {
      return /*#__PURE__*/_jsx(CommentPreview, {
        value: answer !== null && answer !== void 0 && answer.isEmptyComment() ? '' : answer === null || answer === void 0 ? void 0 : answer.comment,
        label: commentPreviewLabel
      });
    }

    if (isCommentEditing) {
      return /*#__PURE__*/_jsx(CommentBox, {
        label: _objectSpread(_objectSpread({}, label), {}, {
          placeholder: label.enterComment
        }),
        onSave: onComment,
        value: answer === null || answer === void 0 ? void 0 : answer.comment,
        onCancel: function onCancel() {
          return setIsCommentEditing(false);
        },
        loading: isCommentLoading
      });
    }

    if (answer !== null && answer !== void 0 && answer.isEmptyComment()) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.disabledText,
        children: /*#__PURE__*/_jsx(RichTextEditor, {
          placeholder: label.enterComment,
          content: "",
          onChange: function onChange() {
            return setIsCommentEditing(true);
          },
          editorLabels: editorLabels,
          disabled: !isAssignmentEnded || isOnGradingProcess,
          scrollable: true
        })
      });
    }

    return /*#__PURE__*/_jsx(CommentPreview, {
      value: answer === null || answer === void 0 ? void 0 : answer.comment,
      label: commentPreviewLabel
    });
  };

  var countWords = function countWords(text) {
    var cleanedText = text.replace(/<[^>]*>/g, ' ');
    var clearSpaceText = cleanedText.trim();

    if (!clearSpaceText) {
      return 0;
    }

    var words = clearSpaceText.split(/\s+/);
    return words.length;
  };

  var renderAnswer = function renderAnswer() {
    var _answer$answerComment, _answer$value, _answer$value2;

    if (answer !== null && answer !== void 0 && answer.isEmpty()) {
      return /*#__PURE__*/_jsx(StyledEmptyAnswerLabel, {
        children: "[".concat(label.noAnswer, "]")
      });
    }

    return /*#__PURE__*/_jsxs(StyledAnswer, {
      direction: "vertical",
      onClick: function onClick() {
        return onClickAnswer(answer === null || answer === void 0 ? void 0 : answer.id.toString());
      },
      children: [/*#__PURE__*/_jsx(EditorComment, {
        onAnswerComment: onAnswerComment,
        content: ((_answer$answerComment = answer.answerComment) === null || _answer$answerComment === void 0 ? void 0 : _answer$answerComment.submissionAnswerContent) || ((_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.text),
        onUpdateAnswerComment: onUpdateAnswerComment,
        onDeleteAnswerComment: onDeleteAnswerComment,
        showComment: true,
        comments: comments,
        setComments: setComments,
        labels: editorCommentLabels
      }), ((_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.audioFile) && /*#__PURE__*/_jsx(AudioPlayer, {
        source: answer.value.audioFile.url
      })]
    });
  };

  return /*#__PURE__*/_jsx(GradingAnswer, _objectSpread(_objectSpread({}, rest), {}, {
    label: label,
    disabled: isGradingLoading || !isAssignmentEnded || isOnGradingProcess || disabled,
    children: /*#__PURE__*/_jsxs(StyledSpaceContainer, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsxs(StyledStudentWork, {
        children: [/*#__PURE__*/_jsx(StyledLabel, {
          children: label.studentWork
        }), (answer === null || answer === void 0 ? void 0 : (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : _answer$value3.text) && /*#__PURE__*/_jsxs(StyledLabel, {
          children: [countWords(answer === null || answer === void 0 ? void 0 : (_answer$value4 = answer.value) === null || _answer$value4 === void 0 ? void 0 : _answer$value4.text), " ", label.word]
        })]
      }), renderAnswer(), /*#__PURE__*/_jsxs(StyledInstructorFeedbackWrapper, {
        children: [/*#__PURE__*/_jsx(StyledLabel, {
          children: label.teacherComment
        }), !isCommentEditing && !(answer !== null && answer !== void 0 && answer.isEmptyComment()) && /*#__PURE__*/_jsx(PrimaryButton, {
          icon: /*#__PURE__*/_jsx(EditOutlined, {}),
          onClick: function onClick() {
            return setIsCommentEditing(true);
          },
          disabled: disabled,
          loading: isCommentLoading
        })]
      }), renderComment()]
    })
  }));
};